var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7617 0V2.6613H13.4652L10.7617 0Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3114 3.71599C9.97737 3.71599 9.7067 3.44531 9.7067 3.1149V0H1.79997C0.808594 0 0 0.791016 0 1.76482V16.2386C0 17.209 0.808594 18 1.79997 18H11.6683C12.6598 18 13.4684 17.209 13.4684 16.2386V3.71599H10.3114ZM9.83318 11.8019C9.83318 12.9902 8.86638 13.957 7.67807 13.957H5.79021C4.6019 13.957 3.6351 12.9902 3.6351 11.8019V9.60823C3.6351 9.06331 4.01839 8.60971 4.53159 8.49724V7.59018C4.53159 6.37729 5.51953 5.38948 6.73242 5.38948H6.73943C7.95232 5.38948 8.94026 6.37729 8.94026 7.59018V8.49724C9.45003 8.60628 9.83675 9.06331 9.83675 9.60823V11.8019H9.83318Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88217 7.5901C7.88217 6.95729 7.36897 6.44409 6.73616 6.44409H6.72902C6.09621 6.44409 5.58301 6.95729 5.58301 7.5901V8.46901H7.88217V7.5901Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69777 9.52399H4.76741C4.72168 9.52399 4.68652 9.55914 4.68652 9.60487V11.7987C4.68652 12.4068 5.18214 12.899 5.79037 12.899H6.20525V11.2115C6.20525 10.9198 6.44077 10.6841 6.73259 10.6841C7.02441 10.6841 7.25993 10.9198 7.25993 11.2115V12.899H7.67824C8.28647 12.899 8.77866 12.4034 8.77866 11.7987V9.60487C8.77866 9.56271 8.7435 9.52399 8.69777 9.52399Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.59877224d6ad665ced55e82a55f81287.svg";
export { ForwardRef as ReactComponent };